const _ = require('lodash');

function createInspirationCardDetail(card) {
    return {
        template: '<wow-inspiration-detail card="card"></wow-inspiration-detail>',
        data: { card }
    };
}

function createInspirationCard(inspirationCard) {
    return {
        template: '<wow-inspiration-card card="contentCard"></wow-inspiration-card>',
        data: { contentCard: inspirationCard },
        detail: createInspirationCardDetail(inspirationCard)
    };
}

function createInspirationCards(inspirationCards) {
    return _.map(inspirationCards, createInspirationCard);
}

module.exports = {
    createInspirationCard,
    createInspirationCards
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-card-factory.js
 **/